import { NODA_DOCS_LINK, NODA_FORM_ROUTER_LINK } from '@shared/constants/links';
import { ICardImages } from '@shared/interfaces/card.interface';

import { IAward, IFooterTypes, Item } from '../types/layout.type';

export const footerData: IFooterTypes[] = [
  {
    title: 'common.header.products',
    items: [
      {
        text: 'common.products.pay-ins.open-banking-payments.subtitle',
        link: '/open-banking',
      },
      {
        text: 'common.products.pay-ins.card-payments.subtitle',
        link: '/card-payments',
      },
      {
        text: 'common.products.pay-ins.checkout-form.subtitle',
        link: '/checkout',
      },
      {
        text: 'common.products.pay-ins.no-code-payment.subtitle',
        link: '/no-code-payment-page',
      },
      {
        text: 'common.products.pay-ins.instant-payment-links.subtitle',
        link: '/payment-link',
      },
      {
        text: 'common.products.pay-outs.bank-payouts.subtitle',
        link: '/bank-payouts',
      },
      {
        text: 'common.products.pay-outs.card-payouts.subtitle',
        link: '/card-payouts',
      },
      {
        text: 'common.products.financial-data.know-your-whales.subtitle',
        link: '/customer-lifetime-value-prediction',
      },
      {
        text: 'common.products.financial-data.sign-in-via-bank.subtitle',
        link: '/bank-sign',
      },
    ],
  },
  {
    title: 'common.header.use-cases',
    items: [
      {
        text: 'common.use-cases.travel.subtitle',
        link: '/use-cases/travel',
      },
      {
        text: 'common.use-cases.ecommerce.subtitle',
        link: '/use-cases/ecommerce',
      },
      {
        text: 'common.use-cases.saas.subtitle',
        link: '/use-cases/saas',
      },
      {
        text: 'common.use-cases.retail.subtitle',
        link: '/use-cases/retail',
      },
      {
        text: 'common.use-cases.marketplaces.subtitle',
        link: '/use-cases/marketplaces',
      },
      {
        text: 'common.use-cases.educational-platforms.subtitle',
        link: '/use-cases/educational-platforms',
      },
      {
        text: 'common.use-cases.online-gaming.subtitle',
        link: '/use-cases/online-gaming',
      },
    ],
  },
  {
    title: 'common.header.about',
    items: [
      {
        text: 'common.about.company.subtitle',
        link: '/about/company',
      },
      {
        text: 'common.about.mission.subtitle',
        link: '/about/who-we-are',
      },
      {
        text: 'common.about.why-open-banking.subtitle',
        link: '/about/why-open-banking',
      },
      {
        text: 'common.about.security.subtitle',
        link: '/about/security-and-data-handling',
      },
      {
        text: 'common.about.legal-privacy.subtitle',
        link: '/about/legal-privacy/terms',
      },
      {
        text: 'common.about.risk-policies.subtitle',
        link: '/about/risk-appetite-policy',
      },
      {
        text: 'common.about.ux-approach.subtitle',
        link: '/about/customer-experience',
      },
      {
        text: 'common.about.partnership.subtitle',
        link: '/about/partnerships',
      },
      {
        text: 'common.about.white-label.footer',
        link: '/about/grow-your-business-with-noda',
      },
    ],
  },
  {
    title: 'common.header.developers',
    items: [
      {
        text: 'common.developers.tech-documentation.title',
        link: NODA_DOCS_LINK,
        staticLink: true,
        staticQuerySaved: true,
      },
      {
        text: 'common.developers.open-banking-demo.title',
        link: '/demo',
      },
      {
        text: 'common.developers.noda-plugins.title',
        link: '/plugins',
      },
    ],
  },
  {
    title: 'common.header.other',
    items: [
      {
        text: 'common.header.pricing',
        link: '/pricing',
      },
      {
        text: 'common.header.articles',
        link: '/articles',
      },
      {
        text: 'common.header.case-studies',
        link: '/articles',
        params: { tag: 'case-studies' },
      },
      {
        text: 'common.header.newsroom',
        link: '/newsroom',
      },
      {
        text: 'common.header.glossary',
        link: '/glossary',
      },
      {
        text: 'common.header.marketplace',
        link: '/marketplace',
      },
    ],
  },
];

export const additionalFooterData: Array<IFooterTypes> = [
  {
    items: [
      {
        text: 'common.header.articles',
        link: '/articles',
      },
      {
        text: 'common.header.glossary',
        link: '/glossary',
      },
    ],
  },
];

export const contactData: IFooterTypes = {
  title: 'common.contact.contact-us',
  titleLink: '/contact-us',
  items: [
    {
      text: 'common.contact.public-relations',
      link: 'mailto:pr@noda.live',
      staticLink: true,
    },
    {
      text: 'common.contact.marketing',
      link: 'mailto:marketing@noda.live',
      staticLink: true,
    },
    {
      text: 'common.contact.client-support',
      link: 'mailto:support@noda.live',
      staticLink: true,
    },
    {
      text: 'common.contact.hr',
      link: 'mailto:hr@noda.live',
      staticLink: true,
    },
    {
      text: 'common.contact.partnership',
      link: 'mailto:partners@noda.live',
      staticLink: true,
    },
  ],
};

export const additionalData: Item[] = [
  {
    text: 'common.contact.terms',
    link: '/about/legal-privacy/terms',
  },
  {
    text: 'common.contact.policy',
    link: '/about/legal-privacy/policy',
  },
  {
    text: 'common.contact.cookie',
    link: '/about/legal-privacy/cookies',
  },
  {
    text: 'common.contact.support',
    link: NODA_FORM_ROUTER_LINK,
  },
];

export const preFooterImagesDark1: ICardImages = {
  picture: 'pre-footer/pre-footer-1',
} as const;

export const preFooterImagesDark2: ICardImages = {
  picture: 'pre-footer/pre-footer--2',
};

export const preFooterImagesDark3: ICardImages = {
  picture: 'pre-footer/pre-footer-3',
} as const;

export const preFooterImagesDark4: ICardImages = {
  picture: 'pre-footer/pre-footer-4',
} as const;

export const preFooterImages1: ICardImages = {
  picture: 'pre-footer/white-pre-footer-1',
} as const;

export const preFooterImages2: ICardImages = {
  picture: 'pre-footer/white-pre-footer-2',
};

export const preFooterImages3: ICardImages = {
  picture: 'pre-footer/white-pre-footer-3',
} as const;

export const preFooterImages4: ICardImages = {
  picture: 'pre-footer/white-pre-footer-4',
} as const;

export const footerAwardsDark: IAward[] = [
  {
    title: 'On the List! 2024',
    image: 'footer/awards/on-the-list-2024.svg',
  },
  {
    title: 'PA connecting the future',
    image: 'footer/awards/pa.svg',
  },
  {
    title: 'PCI DSS',
    image: 'footer/awards/pci-dss.svg',
  },
  {
    title: 'LEIRegister',
    image: 'footer/awards/lei-register.svg',
  },
];

export const footerAwardsWhite: IAward[] = [
  {
    title: 'On the List! 2024',
    image: 'footer/awards/white-on-the-list-2024.svg',
  },
  {
    title: 'PA connecting the future',
    image: 'footer/awards/white-pa.svg',
  },
  {
    title: 'PCI DSS',
    image: 'footer/awards/white-pci-dss.svg',
  },
  {
    title: 'LEIRegister',
    image: 'footer/awards/white-lei-register.svg',
  },
];
